<div class="loader-container" [class.is-loading]="isLoading">
  <div class="loader-container__loader" *ngIf="isLoading">
    <mat-spinner color="primary" [diameter]="spinnerSize"></mat-spinner>
  </div>
  <div class="loader-container__content">
    <ng-content></ng-content>
  </div>
</div>
